// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root{
  background: transparent !important;
}
body{
  background: transparent !important;
} 
html{
  background: transparent !important;
} 
iframe{
  background: transparent !important;
} 

.prism-pop {
  width: 99%;
  height: 100%;
  padding: 10px;
  background: transparent;
}

.prism-robo {
  width: 100%;
  box-shadow: 0px 0px 5px #969494;
  border-radius: 10px;
  background-color: #fcfcfc;
}

.prism-robo-header {
  border-bottom: 1px solid rgb(220, 217, 217);
}

.avatar-container {
  width: 80px;
  height: 80px;
  font-size: 40px;
  object-fit: cover;
  border-radius: 50%;
}

.toggle-button {
  display: none;
}

.question-container {
  padding: 6px;
  min-height: 360px;
  max-height: 360px;
  overflow-y: auto;
  margin: 0px;
  background: #eaeef3;
  padding-left: 10px;
}

input[type="text"],
input[type="email"],
input[type="tel"] {
  background: none !important;
  outline: none !important;
}

.registration-form {
  border-top: 1px solid #dcd9d9;
  font-size: 16px;
  font-weight: 500;
}

form {
  background: #fff;
}

.custom-btn {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  height: 40px;
  margin-top: 2px;
  margin-right  : 10px;
  padding: 0;
  border: none;
}

.custom-btn.rounded-circle {
  border-radius: 50%;
}

.visit-btn {
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: rgb(0, 102, 204);
}

.form-control.text-field:focus {
  border: none;
  outline: 0;
  box-shadow: none;
}

.text-field::placeholder {
  color: rgba(183, 183, 185, 0.726);
}

.custom-btn {
  background: none;
  border: none;
  outline: none;
  margin-left: 6px;
  color: #969494;
}

#Message {
  outline: none;
  border: none;
}

.pointer {
  cursor: pointer;
}
.powered_by{
  color: #969494;
  font-size: 14px;
  height: 24px;
}

.powered_by img{
  height: 100%;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/chat-bot/chatBot.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["#root{\n  background: transparent !important;\n}\nbody{\n  background: transparent !important;\n} \nhtml{\n  background: transparent !important;\n} \niframe{\n  background: transparent !important;\n} \n\n.prism-pop {\n  width: 99%;\n  height: 100%;\n  padding: 10px;\n  background: transparent;\n}\n\n.prism-robo {\n  width: 100%;\n  box-shadow: 0px 0px 5px #969494;\n  border-radius: 10px;\n  background-color: #fcfcfc;\n}\n\n.prism-robo-header {\n  border-bottom: 1px solid rgb(220, 217, 217);\n}\n\n.avatar-container {\n  width: 80px;\n  height: 80px;\n  font-size: 40px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.toggle-button {\n  display: none;\n}\n\n.question-container {\n  padding: 6px;\n  min-height: 360px;\n  max-height: 360px;\n  overflow-y: auto;\n  margin: 0px;\n  background: #eaeef3;\n  padding-left: 10px;\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"tel\"] {\n  background: none !important;\n  outline: none !important;\n}\n\n.registration-form {\n  border-top: 1px solid #dcd9d9;\n  font-size: 16px;\n  font-weight: 500;\n}\n\nform {\n  background: #fff;\n}\n\n.custom-btn {\n  width: 40px;\n  min-width: 40px;\n  max-width: 40px;\n  height: 40px;\n  margin-top: 2px;\n  margin-right  : 10px;\n  padding: 0;\n  border: none;\n}\n\n.custom-btn.rounded-circle {\n  border-radius: 50%;\n}\n\n.visit-btn {\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: rgb(0, 102, 204);\n}\n\n.form-control.text-field:focus {\n  border: none;\n  outline: 0;\n  box-shadow: none;\n}\n\n.text-field::placeholder {\n  color: rgba(183, 183, 185, 0.726);\n}\n\n.custom-btn {\n  background: none;\n  border: none;\n  outline: none;\n  margin-left: 6px;\n  color: #969494;\n}\n\n#Message {\n  outline: none;\n  border: none;\n}\n\n.pointer {\n  cursor: pointer;\n}\n.powered_by{\n  color: #969494;\n  font-size: 14px;\n  height: 24px;\n}\n\n.powered_by img{\n  height: 100%;\n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
